export default __webpack_public_path__ + "static/media/icon_home.dea22bbd.png";